import { useQuery } from "@tanstack/react-query";
import { HelpService } from "../services/help";

export function useGetServicePhoneNumber() {
   const { data, error, isLoading, isError } = useQuery({
      queryKey: ['getServicePhoneNumber'],
      queryFn: HelpService.getServicePhoneNumber,
      retry: 0
   })

   return {
      callCenterPhone: data?.callCenterPhone,
      error,
      isLoading,
      isError
   };
}